module.exports = __webpack_public_path__ + "static/logo-white-on-blue-79e0d5b8bf10be53b21cdfa02c9270f9.svg";